// Module
var code = `<ex-multi-occurrence-maitre-details-ecran lbl-titre="LBL_DEF" multi-occurrence-out="vm.multiOccurrence" multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-maitre-details-ecran>`;
// Exports
module.exports = code;